import {Component, EventEmitter, forwardRef, Input, Output, Provider} from '@angular/core';
import {ControlValueAccessor, NG_VALUE_ACCESSOR} from '@angular/forms';

export const STYLIZED_CHECKBOX_VALUE_ACCESSOR: Provider = {
  provide: NG_VALUE_ACCESSOR,
  useExisting: forwardRef(() => StylizedCheckboxComponent),
  multi: true
};

@Component({
  selector: 'stylized-checkbox',
  templateUrl: './stylized-checkbox.component.html',
  styleUrls: ['./stylized-checkbox.component.scss'],
  providers: [STYLIZED_CHECKBOX_VALUE_ACCESSOR]
})
export class StylizedCheckboxComponent implements ControlValueAccessor {

  @Input() checkboxId: string;
  @Output() change = new EventEmitter<boolean>();

  private innerValue: boolean;
  private onChange: Function;

  constructor() {
  }

  get value(): boolean {
    return this.innerValue;
  }

  set value(value: boolean) {
    this.innerValue = value;
    this.change.emit(value);
    if (this.onChange) {
      this.onChange(value);
    }
  }

  toggle() {
    this.value = !this.value;
  }

  writeValue(value: boolean) {
    this.innerValue = value;
  }

  registerOnChange(fn: (value: boolean) => void) {
    this.onChange = fn;
  }

  registerOnTouched(fn: () => void) {
    // Not implemented
  }
}
